import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GridApi } from "@ag-grid-community/core";
import { Subject, takeUntil } from 'rxjs';
import { HeaderService } from 'src/app/components/header/header.service';

import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';

@Component({
  selector: 'app-shipment-name-cell-renderer',
  templateUrl: './shipment-name-cell-renderer.component.html',
  styleUrls: ['./shipment-name-cell-renderer.component.scss']
})
export class ShipmentNameCellRendererComponent implements OnDestroy {
  params:any;
  copied: boolean;
  ignore: boolean = false;
  gridApi: GridApi;
  fba: boolean = false;
  isShipmentInfo:boolean = false;
  private destroy$ = new Subject<void>();
  isShipment:boolean = false;
  isWalmart:boolean = false;
  constructor(
    private router:Router,
    private shipyardService: ShipyardService,
    private headerService:HeaderService
    ){
      this.headerService.accountSelectedType
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        if (e) {
          this.isWalmart = e[0] === "Walmart";     
        }
      }
    );
    }

  agInit(params: any): void {
    this.gridApi= params.api;
    this.fba = params?.fba;
    this.isShipmentInfo = params?.isShipmentInfo;
    this.isShipment = params?.isShipment;
    this.params = params.data;
    this.params.ShipmentId =  this.params.ShipmentId || this.params.amazonShipmentId || this.params.AmazonShipmentId;
    this.params.shipmentHeaderId = this.params.shipmentHeaderId || this.params.ShipmentHeaderId;
    this.params.ShipmentName = this.params.ShipmentName || this.params.shipmentName;
  }

  copy(e) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  openLink(event: MouseEvent, selectedRow,isShipment?) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/shipyard/shipments/detail', selectedRow.ShipmentHeaderId || selectedRow.shipmentHeaderId])
      );
      if ((selectedRow?.ShipTo?.toLowerCase() === 'amazon' && selectedRow?.ShipmentHeaderId) || isShipment) {
        if (event.ctrlKey || event.metaKey) {
          window.open(url, '_blank');
        } else {
          this.router.navigateByUrl(url);
        }
      }
    }
  openOnAmazon(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(
      `https://sellercentral.amazon.com/fba/inbound-shipment/summary/${this.params.AmazonShipmentId}`,
      "_blank"
    );
  }

  searchInput(value){
    this.shipyardService.selectedCellValue$.next(value);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
